import axios from "axios";
import swal from "sweetalert";

import { InitPage } from "../index";
import Cookies from "js-cookie";

declare var clientCode: string;
declare var storeCode: string;
declare var invoiceId: string;
declare var scheduleId: string;

interface Print {
  printer_id: string | number | string[];
  copies: string | number | string[];
}

class PrintAction {
  constructor() {
    const _this = this;
    $("document").ready(function () {
      $("#submit-print_action-form").val("Print");

      $("#print-actions-btn").on("click", function () {
        $("#print-actions-modal").modal("show");
      });

      $("#print_action_form").on("submit", function (event) {
        event.preventDefault();
        const printer_id = $("#printer").val();
        const copies = $("#input_copies").val();
        Cookies.set("crm_printer", printer_id);

        switch ($("input[name='action_type']:checked").val()) {
          case "print_bol":
            _this.printBol({ printer_id, copies });
            break;

          case "preview_bol":
            _this.previewBol({ printer_id, copies: 1 });
            break;

          case "print_invoice":
            _this.printInvoice({ printer_id, copies });
            break;

          case "preview_invoice":
            _this.previewInvoice({ printer_id, copies: 1 });
            break;

          default:
            return;
        }
      });
    });
  }

  printBol(print: Print) {
    this.peformPrintAction(this.performPrintBol, print);
  }

  previewBol({ printer_id, copies }: Print) {
    window.open(
      `/${clientCode}/${storeCode}/api/v1/crm/schedules/${scheduleId}/preview.pdf?printer_id=${printer_id}&copies=${copies}`,
      "_blank",
    );

    $("#print-actions-modal").modal("hide");
  }

  printInvoice(print: Print) {
    this.peformPrintAction(this.performPrintInvoice, print);
  }

  previewInvoice({ printer_id, copies }: Print) {
    window.open(
      `/${clientCode}/${storeCode}/api/v1/crm/invoices/${invoiceId}/preview.pdf?printer_id=${printer_id}&copies=${copies}`,
      "_blank",
    );

    $("#print-actions-modal").modal("hide");
  }

  async performPrintBol({ printer_id, copies }: Print) {
    const instance = axios.create({ withCredentials: true });
    return instance.get(
      `/${clientCode}/${storeCode}/api/v1/crm/schedules/${scheduleId}/print?printer_id=${printer_id}&copies=${copies}`,
    );
  }

  async performPrintInvoice({ printer_id, copies }: Print) {
    const instance = axios.create({ withCredentials: true });
    return instance.get(
      `/${clientCode}/${storeCode}/api/v1/crm/invoices/${invoiceId}/print?printer_id=${printer_id}&copies=${copies}`,
    );
  }

  async peformPrintAction(method: any, print: Print) {
    method(print)
      .then(() => {
        swal.close();
        swal({
          title: "Success",
          text: "The print initiated",
          icon: "success",
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "Close",
              value: null,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-silver",
              closeModal: true,
            },
          },
        }).then(() => {
          $("#input_copies").val(1);
        });
      })
      .catch((error: any) => {
        swal.close();
        swal({
          title: "Error",
          text: error.message,
          icon: "error",
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "Close",
              value: null,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-silver",
              closeModal: true,
            },
          },
          dangerMode: true,
        });
      });

    $("#print-actions-modal").modal("hide");
    swal({
      title: "Print(s) are in progress",
      closeOnClickOutside: false,
    });
  }
}

export function LoadPage() {
  InitPage("schedules edit", () => new PrintAction());
  InitPage("invoices edit", () => new PrintAction());
}
